import { isString } from './assertion.esm.js';
import { isSSR } from './ssr.esm.js';

function replaceAll(target, search, replacement) {
  if (isString(search)) {
    return target.split(search).join(replacement);
  }

  return Object.entries(search).reduce(function (current, _ref) {
    var find = _ref[0],
        replace = _ref[1];
    return replaceAll(current, find, replace);
  }, target);
}
function decodeHTML(input) {
  if (input === void 0) {
    input = '';
  }

  if (isSSR()) {
    return input;
  }

  var txt = document.createElement('textarea');
  txt.innerHTML = input;
  return txt.value;
}
function escapeHTML(input) {
  if (input === void 0) {
    input = '';
  }

  return input.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#039;');
}
function pluralize(input, singular, plural) {
  if (input === 1) {
    return singular;
  }

  return plural;
}

export { decodeHTML, escapeHTML, pluralize, replaceAll };
//# sourceMappingURL=string.esm.js.map
